import { request } from '@@/plugin-request';

export async function queryStudents(params) {
  return request('/api/sales/students', {
    method: 'GET',
    params,
  });
}
